export const EVENTS = [
  'afterLoad',
  'onLeave',
  'afterRender',
  'afterResize',
  'afterResponsive',
  'afterSlideLoad',
  'onSlideLeave',
];

export const METHODS = [
  'moveSectionUp',
  'moveSectionDown',
  'moveTo',
  'silentMoveTo',
  'moveSlideRight',
  'moveSlideLeft',
  'setAutoScrolling',
  'setFitToSection',
  'fitToSection',
  'setLockAnchors',
  'setAllowScrolling',
  'setKeyboardScrolling',
  'setRecordHistory',
  'setScrollingSpeed',
  'destroy',
  'reBuild',
  'setResponsive',
  'responsiveSlidesToSections',
  'responsiveSlidesToSlides',
];


// WEBPACK FOOTER //
// ./src/constants.js